import { styled } from '@linaria/react';

import { radius, semantic, size, space, textStyle } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-200']};
  box-sizing: border-box;
  padding: ${space['space-400']};
  border: ${size.stroke['stroke-default']} solid ${semantic.border.primary};
  border-radius: ${radius('card', 'radius-sm')};
`;

export const Trigger = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space['space-300']};
  width: 100%;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  font-family: ${textStyle.title.sm.fontFamily};
  font-size: ${textStyle.title.sm.fontSize};
  font-weight: ${textStyle.title.sm.fontWeight};
  line-height: ${textStyle.title.sm.lineHeight};
  letter-spacing: ${textStyle.title.sm.letterSpacing};
  color: ${semantic.text.primary};

  &:focus-visible {
    outline: ${size.stroke['stroke-thick']} solid ${semantic.border.selected};
    outline-offset: ${space['space-050']};
  }
`;

export const IndicatorWrapper = styled.span`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  padding: ${space['space-300']};
  border-radius: ${size.radius['radius-full']};
`;

export const Indicator = styled.span`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: ${size.icon['icon-md']};
  height: ${size.icon['icon-md']};
  border: ${size.stroke['stroke-default']} solid ${semantic.border.secondary};
  border-radius: ${size.radius['radius-xs']};
  background: ${semantic.bg.canvas};
  color: ${semantic.text.inverse};
  transition: background 0.15s ease, border-color 0.15s ease;

  &[data-checked='true'] {
    background: ${semantic.bg.positiveStrong};
    border-color: transparent;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-200']};
`;
